const api = 'https://cms-allianz-lp-cote.valide.vc/'

export const environment = {
	api: `${api}`,
	env: 'dev',
	splitPoint: '.vc',
	production: false,
}
